var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoldBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    "aria-label": "Verified account",
    role: "img",
    className: "r-4qtqp9 r-yyyyoo r-1xvli5t r-9cviqr r-f9ja8p r-og9te1 r-bnwqim r-1plcrui r-lrvibr",
    "data-testid": "icon-verified",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "146-a",
    x1: 4.411,
    x2: 18.083,
    y1: 2.495,
    y2: 21.508,
    fill: "#F7F9F9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4e72a",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#cd8105",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#cb7b00",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4ec26",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4e72a",
    fill: "#F7F9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "146-b",
    x1: 5.355,
    x2: 16.361,
    y1: 3.395,
    y2: 19.133,
    fill: "#F7F9F9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e87f",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#e2b719",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#e2b719",
    fill: "#F7F9F9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F7F9F9"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "146-a",
    x1: 4.411,
    x2: 18.083,
    y1: 2.495,
    y2: 21.508,
    fill: "#F7F9F9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4e72a",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#cd8105",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#cb7b00",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4ec26",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4e72a",
    fill: "#F7F9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "146-b",
    x1: 5.355,
    x2: 16.361,
    y1: 3.395,
    y2: 19.133,
    fill: "#F7F9F9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e87f",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#e2b719",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#e2b719",
    fill: "#F7F9F9"
  })), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    fill: "#F7F9F9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.324 3.848L11 1.6 8.676 3.848l-3.201-.453-.559 3.184L2.06 8.095 3.48 11l-1.42 2.904 2.856 1.516.559 3.184 3.201-.452L11 20.4l2.324-2.248 3.201.452.559-3.184 2.856-1.516L18.52 11l1.42-2.905-2.856-1.516-.559-3.184zm-7.09 7.575l3.428 3.428 5.683-6.206-1.347-1.247-4.4 4.795-2.072-2.072z",
    fill: "url(\"#146-a\")"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.101 4.533L11 2.5 8.899 4.533l-2.895-.41-.505 2.88-2.583 1.37L4.2 11l-1.284 2.627 2.583 1.37.505 2.88 2.895-.41L11 19.5l2.101-2.033 2.895.41.505-2.88 2.583-1.37L17.8 11l1.284-2.627-2.583-1.37-.505-2.88zm-6.868 6.89l3.429 3.428 5.683-6.206-1.347-1.247-4.4 4.795-2.072-2.072z",
    fill: "url(\"#146-b\")"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.233 11.423l3.429 3.428 5.65-6.17.038-.033-.005 1.398-5.683 6.206-3.429-3.429-.003-1.405.005.003z",
    fill: "#D18800"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldBadge);
export default __webpack_public_path__ + "static/media/gold-badge.f179486a63b4f15f0bb7d8930db5bb37.svg";
export { ForwardRef as ReactComponent };